import styled from 'styled-components'
import { getContainerStyles } from './style'
import { ContainerProps } from './type'

const Container = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        ![
            'display',
            'flex',
            'alignItems',
            'justifyContent',
            'flexWrap',
            'flexDirection',
            'rowGap',
            'columnGap',
            'position',
            'top',
            'bottom',
            'left',
            'right',
            'zIndex',
            'paddingTop',
            'paddingBottom',
            'paddingLeft',
            'paddingRight',
            'marginTop',
            'marginBottom',
            'marginLeft',
            'marginRight',
            'backgroundColor',
            'cursor',
            'width',
            'height'
        ].includes(prop)
})<ContainerProps>(getContainerStyles)

export default Container
